// extracted by mini-css-extract-plugin
var _1 = "PostSeriesFooter-module__animatedBackground--zot0k";
var _2 = "PostSeriesFooter-module__container--zqM91";
var _3 = "PostSeriesFooter-module__icon--mhPrE";
var _4 = "PostSeriesFooter-module__meta--svgRW";
var _5 = "PostSeriesFooter-module__next--njGJo";
var _6 = "PostSeriesFooter-module__paginationItem--_Ccvt";
var _7 = "PostSeriesFooter-module__postTitle--G0pZw";
var _8 = "PostSeriesFooter-module__prev--WicRN";
export { _1 as "animatedBackground", _2 as "container", _3 as "icon", _4 as "meta", _5 as "next", _6 as "paginationItem", _7 as "postTitle", _8 as "prev" }
